var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.searchActive
    ? _c(
        "div",
        {
          staticClass: "header-site-search-form",
          class: { "is-open": !_vm.collapsed },
        },
        [
          _c("form", { attrs: { action: "search-results", method: "GET" } }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      ref: "headerSearch",
                      staticClass: "form-control header-search-input",
                      attrs: {
                        id: "header-search-query",
                        type: "text",
                        name: "web-search",
                        placeholder: "Search Website...",
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape",
                            ])
                          )
                            return null
                          return _vm.clearInput.apply(null, arguments)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "input-group-btn" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-nav-search close-search",
                          attrs: { id: "header-close-search", type: "button" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.triggerHideHeaderSearch.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "icon",
                            attrs: { icon: "times" },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "header-search-description" }, [
          _c("div", { staticClass: "header-search-text" }, [
            _vm._v(
              "\n              Hit enter to search or ESC to close\n            "
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }